export let routes = [
  {
    path: '/x3-side-student-clues',
    name: 'x3-side-student-clues',
    component: () => import('@x3/js/side/student-clues/student-clues.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsStudentClues(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-student-clues',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
